<template>
    <b-container fluid class="accessible-map d-flex flex-column p-0 m-0" :style="{fontSize : displayFontSize }">
        <nav-bar />
        <router-view></router-view>
        <mobile-map v-show="showMap" :tma="tma" :key="`map_for_${tma}`" />
    </b-container>
</template>

<script>
    import mobileMap from '../../components/geo/maps/WebAccessible.vue';
    import WebNavBarAccessible from '../../components/geo/panels/navbar/WebNavBarAccessible.vue';
    export default {
        props: ['tma'],
        components: {
            'mobile-map': mobileMap,
            'nav-bar': WebNavBarAccessible
        },
        computed: {
            showMap() {
                return this.$route.meta.showMap;
            },
            displayFontSize() {
                return this.$store.state.accessibility.options.fontSize;
            }
        }
    };
</script>

<style lang="scss">
    .accessible-link {
        &:focus {
            border: 2px solid black;
        }
    }
</style>
<style lang="scss" scoped>
    .accessible-map {
        height: 100%;
    }
    .info {
        background: transparent;
    }

</style>
